module.exports = __webpack_public_path__ + "static/img/home-infectious-disease.444d1fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home-infectious-disease.jpg
// module id = 1Y3w
// module chunks = 0